module.exports = __webpack_public_path__ + "img/minus.2a4d3add.svg";